import * as React from 'react';
import { ReactElement } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Heading, Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import { Layout } from '../index';
import GlobalErrors from '../../module/GlobalErrors';
import PravoEuList from '../../module/VyhladavaniePravoEu/PravoEuList';
import usePravoEuFilterFromUrl from '../../module/VyhladavaniePravoEu/hooks/usePravoEuFilterFromUrl';

const VyhladavaniePravoEuPage = (): ReactElement => {
  const {
    initialFilter,
    initialFilterLoading,
  } = usePravoEuFilterFromUrl();

  return (
    <Layout>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.pravoEu.list.to,
            heading: routes.pravoEu.list.name,
          }]}
      />
      <GlobalErrors />
      <Heading size="xl">Právo Európskej únie</Heading>
      <Loader loading={initialFilterLoading}>
        <>
          {initialFilter && (
          <PravoEuList initFilter={initialFilter} />
          )}
        </>
      </Loader>
    </Layout>
  );
};

export default VyhladavaniePravoEuPage;
